export type SearchType = 'single' | 'type'

export enum SearchTypeEnum {
  Single = 'single',
  Type = 'type',
}
